import { FirebaseOptions, initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import Config from '../../firebaseConfig.json'
// Initialize Firebase

const firebaseApp = initializeApp(Config as FirebaseOptions)
export const auth = getAuth(firebaseApp)
